<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-text-field code="membre_nom" v-model="sasInspection1.nom" disabled></opq-text-field>

    <opq-text-field code="membre_prenom" v-model="sasInspection1.prenom" disabled></opq-text-field>

    <opq-text-field code="membre_numero" v-model="sasInspection1.noPermis" disabled></opq-text-field>

    <opq-catalogue code="changement-pratique" v-model="sasInspection1.changementPratique" :live="liveSasInspection1(12305)"></opq-catalogue>

    <opq-catalogue
      :opq-if="estChangementPratique"
      code="changement-secteurs-dactivite"
      v-model="sasInspection1.changementSecteursDActivite"
      :live="liveSasInspection1(12306)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estChangementPratique"
      code="changement-activites-reservees"
      v-model="sasInspection1.changementActivitesReservees"
      :live="liveSasInspection1(12307)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estChangementPratique"
      code="changement-clientele"
      v-model="sasInspection1.changementClientele"
      :live="liveSasInspection1(12308)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estChangementPratique"
      code="changement-services-offerts"
      v-model="sasInspection1.changementServicesOfferts"
      :live="liveSasInspection1(12309)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estChangementPratique"
      code="changement-modeles-theoriques"
      v-model="sasInspection1.changementModelesTheoriques"
      :live="liveSasInspection1(12310)"
    ></opq-catalogue>

    <opq-memo
      :opq-if="estChangementPratique"
      code="changement-commentaires"
      v-model="sasInspection1.commentaireModelesTheoriques"
      :live="liveSasInspection1(12311)"
    ></opq-memo>

    <opq-catalogue
      :opq-if="estChangementPratique"
      code="ouverture-cabinet"
      v-model="sasInspection1.ouvertureCabinetDepuis5Ans"
      :live="liveSasInspection1(12312)"
    ></opq-catalogue>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormSimple, CataloguesHelper],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasInspection1() {
      return this.sas.sasInspection1
    },

    estChangementPratique() {
      return this.estOui(this.sasInspection1.changementPratique)
    }
  },

  methods: {
    liveSasInspection1(cle) {
      return { endpoint: "/sas-inspection-1/", cle: cle, fileId: this.sasInspection1.id }
    }
  }
}
</script>

<style>
</style>